import { Dimensions, Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { lightGrey } from 'utils/colors';

const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
    root: {
        width: width - 60,
        flexDirection: 'row',
    },
    title: {
        maxWidth: width - 110,
        fontFamily: Fonts.main.bold,
        fontSize: 20,
        lineHeight: Platform.select({
            ios: 0,
            default: 30,
        }),
        color: lightGrey(),
    },
    appendText: {
        fontFamily: Fonts.main.regular,
        fontSize: 20,
        color: lightGrey(0.7),
        marginLeft: 8,
    },
});

export default styles;
